<!--右侧浮动-二维码加询价清单-->'
<template>
  <div class="right-tab-bar">
        <ul class="right-floating">
          <li @click="drawer=true" v-if="userInfo.type==2">
            <i class="iconfont icon-gouwuche"></i>
            <p>待询价</p>
            <div class="badge" v-if="inquiryList.length>0">{{inquiryList.length}}</div>
          </li>
          <li @mouseenter="isShow = true" @mouseleave="isShow = false">
            <i class="iconfont icon-weixin2"></i>
            <p>微信</p>
            <div class="rw-qr" v-if="isShow">
                <img src="/images/logo/rw.png" alt="">
                <div>微信扫一扫访问小程序</div>
            </div>
          </li>
        </ul>
        <el-drawer
            title="询价清单"
            :visible.sync="drawer"
            :size="400"
            direction="rtl"
            >
            <ul class="inquiry-list">
                <li v-for="(item, index) in inquiryList" :key="index">
                    <div class="inquiry-baner">
                        <template v-for="(img,index) in item.pic.split(',')" >
                            <img v-lazy="ImgPreUrl+img"   class="banner" :key="index" v-if="index==0">
                        </template>
                    </div>
                    <div class="inquiry-info">
                        <div class="inquiry-price">
                            <h3 class="inquiry-title">
                                {{item.title| formatString(20)}}
                                <img v-lazy="'/images/zfxj/icon_'+item.state_star+'.png'" :key="item.state_star" height="16px" v-if="item.state_star>0"/>
                                <img v-lazy="'/images/xj/icon_'+item.star+'.png'" :key="item.star" height="16px" v-else />
                            </h3>
                            <div class="inquiry-address mt-2">
                                <i class="el-icon-location-information text-login mr-1"></i>{{ parseAddress(item) }}
                            </div>
                        </div>
                        <div class="delete-btn mt-1" @click="handleDelete(item)">
                            <el-button type="danger"  size="mini" >删除</el-button>
                        </div>
                    </div>
                </li>
                <li v-if="inquiryList.length==0" class="inquiry-no-data">
                     <img src="/images/prompt/icon_1.png" alt="">
                    <div class="no-data">暂无询价酒店、请尝试添加</div>
                </li>
            </ul>
            <el-button type="primary" @click="bookHotel()" :disabled="inquiryList.length==0" class="inquiry-botton">提交询价</el-button>
        </el-drawer>
  </div>
</template>

<script>
import { mapMutations,mapState,mapGetters} from 'vuex'
import provinces from '@/assets/utils/provinces'             //省份信息
export default {
  name: 'RightTabBar',
  components: {},
  props: {},
  data() {
    return {
        isShow: false,               //二维码显示状态
        drawer: false               //弹出方向
    };
  },
  computed: {
        ...mapGetters(['userInfo']),
        ...mapState(['inquiryList']),
  },
  watch: {},
  created() {},
  mounted() {},
  methods: {
        ...mapMutations(['UPDATEINQUIRYLISTINFO']),
        //获取本地地址信息
        parseAddress(res){
        let city = provinces.find(item => item.id == res.city);
        let district = provinces.find(item => item.id == res.district);
        return `${city.title}${district.title}${res.address}`;
        },
        //删除询价
        handleDelete(item){
            this.$message.success('删除成功！');
            this.UPDATEINQUIRYLISTINFO({infoList:item,modify:'deletes'});
        },
        //提交询价
        bookHotel(hotelInfo) {
            this.$router.push({name: 'OrderPost', query: {isHotelInquiry:1}});
        },
    }
};
</script>

<style lang="scss" scoped>
    .right-floating{
        background-color: #fff;
        position: fixed;
        right: 0;
        border-radius: 8px 0 0 8px;
        bottom: 40%;
    }
    .right-floating li{
        padding: 14px;
        cursor: pointer;
        position: relative;
        text-align: center;
        &:hover{
            background-color: var(--smtc-color-primary);
            color: #fff;
            border-radius: 8px 0 0 8px;
        }
        i{
            font-size: 22px;
        }
        p{
           margin-top: 4px;
           font-size: 12px;
        }
    }
    .badge{
        position: absolute;
        top: 8px;
        right: 12px;
        width: 18px;
        height: 18px;
        background-color: var(--smtc-color-text-red);
        border-radius: 50px;
        color: #fff;
        line-height: 18px;
        font-size: 11px;
    }
    .rw-qr{
        position: absolute;
        top: -90px;
        left: -170px;
        background-color: #fff;
        width: 160px;
        height: 180px;
        box-shadow: 0 0 30px 0px rgba(97, 105, 119, .18);
        border-radius: 8px;
        img{
            width: 130px;
            height: 130px;
            margin-top: 10px;
        }
        div{
            color: #666 !important;
            font-size: 12px;
            margin-top: 6px;
        }
    }
    .inquiry-price{
        height: 86px;
    }
    .inquiry-info{
        width: 65%;
        text-align: left;
    }
    .inquiry-list{
        height: 94%;
        min-height: 60%;
        background-color: #f3f4f8;
        overflow:auto;
        li{
            width: 90%;
            margin: 0 auto;
            background-color: #fff; 
            box-shadow: -2px 0 30px 2px rgba(97, 105, 119, 0.18);
            display: flex;
            border-radius: 6px;
            overflow: hidden;
            padding: 3%;
            margin-top: 20px;
        }
        .inquiry-no-data{
 
            background-color: inherit;
            box-shadow: none;
            flex-direction: column;
            text-align: center;
            img{
                width: 70%;
                display: inline-block;
                margin: 0 auto;
            }
        }
    }
    .inquiry-baner{
        width: 120px;
        height: 120px;
        overflow: hidden;
        margin-right: 20px;
        border-radius: 6px;
        img{
            width: 100%;
            height: 100%;
        }
    }
    .inquiry-botton{
        display: block;
        width: 90%;
        margin: 0 auto;
        margin-top: 1.5vh;
    }
    .delete-btn{
        text-align: right;
        width: 100%;
    }
    
</style>
<style>
  .right-tab-bar .el-drawer__header{
    text-align:left;
  }
</style>
